export { default } from './InnerHero';
